import { render } from "./PayPassword.vue?vue&type=template&id=c078f0f2&scoped=true"
import script from "./PayPassword.vue?vue&type=script&lang=js"
export * from "./PayPassword.vue?vue&type=script&lang=js"

import "./PayPassword.vue?vue&type=style&index=0&id=c078f0f2&lang=scss&scoped=true"
import "./PayPassword.vue?vue&type=style&index=1&id=c078f0f2&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c078f0f2"]])

export default __exports__